Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = isInclusivelyAfterDay;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _isSameDay = require('./isSameDay');

var _isSameDay2 = _interopRequireDefault(_isSameDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isInclusivelyAfterDay(a, b) {
  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
  return a.isAfter(b) || (0, _isSameDay2['default'])(a, b);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dates/lib/utils/isInclusivelyAfterDay.js
// module id = 133
// module chunks = 0